var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "collapse",
        { attrs: { title: "Relación de los servicios con fondos públicos" } },
        [
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: {
                  "custom-messages": {
                    required: "El campo es requerido."
                  },
                  rules: "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": errors[0],
                              error: errors[0],
                              label:
                                "Explicación de cómo los servicios a solicitar no reemplazan o sustituyen actividades que deban ser sufragadas con fondos estatales, locales o de otros programas federales; excepto que por disposición de una ley federal se indique lo contrario.",
                              maxlength: 10000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model,
                              callback: function($$v) {
                                _vm.model = $$v
                              },
                              expression: "model"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3184863904
                )
              })
            : _vm.isReadOnly
            ? _c("div", { staticClass: "my-2" }, [
                _c("div", { staticClass: "my-2" }, [
                  _vm._v(
                    " Explicación de cómo los servicios a solicitar no reemplazan o sustituyen actividades que deban ser sufragadas con fondos estatales, locales o de otros programas federales; excepto que por disposición de una ley federal se indique lo contrario. "
                  )
                ]),
                _c("label", { staticClass: "data-label" }, [
                  _vm._v(" " + _vm._s(_vm._f("empty")(_vm.model)) + " ")
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }